module.exports = "data:image/png;base64,UklGRroAAABXRUJQVlA4TK4AAAAvE8AEEFWwbSQpzPXf9AB2Sn68ItzW2vYkXwXmvAJ5Eu11AKj/CWgZQcf4/p7arFXWATi0OXXvBPTeNCxX2xP6Hz3iaWWYHmJIwN1FC2KbUC1Fo3bxAAkTDy9UY4Ea7CjeCr5RqDwgZZ790v1ByLEIfb0Uct8fC45w/Ok/T0ECtzXkK7wotqAWGIfKBZIpGXcnNYisQrUWj9bJAyTMEAPL60DohdrqE/ZaOWaE7g0="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workspace/unlimited.png
// module id = I4Dp
// module chunks = 1